module.exports = __webpack_public_path__ + "static/media/emmanuel_hernandez.f338493b.png";